import {
  Home as HomeIcon,
  People as ContactsIcon,
  Inbox as InboxIcon,
  Assignment as ServiceIcon,
  Storefront as CatalogIcon,
  Receipt as OrderIcon,
  ListAlt as CampaignsIcon,
  TrendingUp as LeadsIcon,
  Event as CalendarIcon
} from '@material-ui/icons'


export const appList = [
  {
    name: "Home",
    appRoot: "./apps/home",
    path: "home",
    icon: HomeIcon,
  },  
  {
    name: "Contacts",
    appRoot: "./apps/contacts",
    path: "contacts",
    icon: ContactsIcon,
    required_permissions: ["contact.browse_contact"],
  },
  // Nav order is this array's order (top nav + mobile bottom nav both map appList
  // directly): Home, Contacts, Inbox, Leads, Projects, then the rest. Calendar stays
  // routable (hideAppIcon) but its entry point moved to two navbar icon buttons —
  // see navigation/index.js.
  {
    name: "Inbox",
    appRoot: "./apps/conversations",
    path: "conversations",
    icon: InboxIcon,
    required_permissions: ["conversation.browse_conversation"],
  },
  {
    name: "Calendar",
    appRoot: "./apps/calendar",
    path: "calendar",
    icon: CalendarIcon,
    required_permissions: ["calendar.browse_event"],
    hideAppIcon: true, // moved to two navbar icon buttons (right side) — see navigation/index.js
  },
  {
    name: "Leads",
    appRoot: "./apps/leads",
    path: "leads",
    icon: LeadsIcon,
    required_permissions: ["lead.browse_lead"],
    action_key: 'leadSchemeList',
  },
  // {
  //   name: "Workflow",
  //   appRoot: "./apps/dummy",
  //   path: "task",
  // },    
  {
    name: "Sales",
    appRoot: "./apps/sales",
    path: "sales",
    hideAppIcon: true, // Not yet ready
  },
  {
    name: "Projects",
    appRoot: "./apps/service",
    path: "service",
    icon: ServiceIcon,
    required_permissions: ["project.browse_issue"],
    action_key: 'projectList'
  },
  {
    name: "Store",
    appRoot: "./apps/catalog",
    path: "catalog",
    icon: CatalogIcon,
    hideAppIcon: true, // hidden so it's not accessible from navbar
  },
  {
    name: "Orders",
    appRoot: "./apps/orders",
    path: "orders",
    icon: OrderIcon,
    required_permissions: ["sales.browse_order"],
  },
  {
    name: "Marketing",
    appRoot: "./apps/marketing",
    path: "marketing",
    hideAppIcon: true, // For experimental only, not production
  },
  {
    name: "Commerce",
    appRoot: "./apps/commerce",
    path: "commerce",
    hideAppIcon: true, // For experimental only, not production
  },
  {
    name: "Settings",
    appRoot: "./apps/settings",
    path: "settings",
    hideAppIcon: true,
  },
  {
    name: "Settings",
    appRoot: "./apps/reports",
    path: "reports",
    hideAppIcon: true,
  },
  {
    name: "Campaigns",
    appRoot: "./apps/campaigns",
    icon: CampaignsIcon,
    path: "campaigns",
    required_permissions: ["outbound.view_message"],
    required_app_settings: ["enable_campaign_app"],
  },
]